export async function getPromiseData(options: any) {
  if (typeof options === "function") {
    return options();
  }
  return options; // Promise.resolve(options)
}

export function convertLanguageCode(code: string) {
  return code.replace("-", "_");
}
